import { Button, Modal } from '@trackman/web-shared-components';
import { PositionBarWrapper } from 'pages/SetLineup/components/PositionBar/PositionBarStyles';
import { Dot } from 'pages/SetLineup/components/TeamSetup/LineupPlayer/LineupPlayerStyles';
import { LineupListWrapper } from 'pages/SetLineup/components/TeamSetup/TeamLineup/TeamLineupStyles';
import React from 'react';
import styled from 'styled-components';
import { borderColorNotes, darkgrey, modalGrey } from 'styles/Colors';

export const Editor = styled.div`
  margin-top: 10px;
  height: calc(100% - 85px);

  ${LineupListWrapper} {
    height: unset;
    overflow-x: unset;
    overflow-y: unset;
  }

  .team-setup {
    height: 100%;
    .tab-content {
      height: 100%;
    }
    ul {
      padding-left: 20px;
      border-bottom: 1px solid ${borderColorNotes};
    }

    .lineup-player {
      border-bottom: 1px solid ${borderColorNotes};
    }

    .roster {
      .roster-players {
        max-height: calc(100% - 50px);
      }
    }
  }
`;

export const StyledModal = styled((props) => <Modal {...props} />)`
  .MuiPaper-root {
    width: 600px !important;
    max-width: 100%;
  }

  ${PositionBarWrapper} {
    padding-left: 10px;
  }

  ${Dot} {
    position: static;
    transform: unset;
    margin-left: 5px;
    display: block;
  }
`;

export const Footer = styled.div<{ justifyContent: string }>`
  padding: 24px 32px;
  display: flex;
  justify-content: ${(props) => props.justifyContent};
`;

export const FooterButtons = styled.div`
  display: flex;
  gap: 8px;
`;

export const StyledButton = styled((props) => <Button {...props} />)`
  &&& {
    background-color: ${modalGrey};
    color: ${darkgrey};

    &:active {
      background-color: ${modalGrey} !important;
    }
  }
`;
